export const LicenseDataItemMockData = {
  id: '821969d5-1c4f-4ed8-a56d-4d9b9a9f656e',
  toolCode: '1234',
  deviceType: 'SGTD',
  fromDate: '2023-06-14T00:00:00-04:00',
  untilDate: '2023-06-14T00:00:00-04:00',
  createdOn: '2023-06-14T15:31:15.1105691-04:00',
  createdBy: 'System Administrator',
  unlimited: false,
  coefficients: false,
  continuous: false,
  multishot: false,
  zupt: false,
  offline: false,
  flash: false,
  notes: 'Mock License Data Notes',
  customer: 'Mock License Data Customer',
  project: 'Mock License Data Project',
  organizationName: 'Mock License Data Organization',
  projects: ['PONE', 'PTWO'],
  customers: ['ONE', 'TWO'],
  needsSignOff: false,
  canCreateUnlimitedLicense: false,
} as any;
